import Vue from "vue";
window.Vue = require("vue");
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) { console.log(e); }

import "bootstrap/dist/css/bootstrap.min.css";

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Content-Type"] = "application/json";
window.axios.defaults.headers.common["Accept"] = "application/json";

const token = localStorage.getItem("user-token");
if (token) {
    window.axios.defaults.headers.common["Authorization"] = token;
}

window.events = new Vue();
window.flash = function (message, level = "success") {
    window.events.$emit("flash", { message, level });
};

window.moment = require('moment');
require('moment/locale/fr.js');
require('moment/locale/de.js');
require('moment/locale/en-gb.js');
moment.locale(i18n.locale);

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import BackToTop from 'vue-backtotop'
Vue.use(BackToTop)

